import { Box, styled, Typography } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { primary } from "../../constants/theme";
import { useMobile } from "../../utils/findViewport";

const CustomBrandLocation = styled(Box)(({ theme }) => ({
  position: "relative",

  "@keyframes moveForward": {
    "0%": {
      transform: "translateX(0)",
    },
    "100%": {
      transform: "translateX(-100%)",
    },
  },

  ".imageStore": {
    position: "absolute",
    height: "25px",
    animation: "moveForward 10s infinite linear ",
  },

  ".offerInfo": {
    fontSize: "12.4px",
    textAlign: "center",
  },
}));

const BrandLocation = () => {
  const mobile = useMobile();
  return (
    <CustomBrandLocation>
      {mobile && (
        <Box>
          <Box display="flex" flexDirection="row">
            <Box style={{ height: "27px" }}>
              <Typography className="offerInfo">
                {" "}
                🎁 Visit <strong>TURNO STORE</strong> for up to{" "}
                {/* 🎁 Visit <strong>TURNO</strong> STORE TO GET UPTO{" "} */}
                <span style={{ color: primary.main, fontWeight: 600 }}>
                  ₹5000
                </span>{" "}
                discount
              </Typography>
            </Box>
            <Box className="imageStore">
              <LazyLoadImage
                effect="opacity"
                // src={imagesList.homeAutoAnimationBg}
                src={`${process.env.NEXT_PUBLIC_CDN_LINK}Retail+Page/webp/brands.webp`}
                alt="Monuments Animation"
                width={"100%"}
                // height={"100%"}
                onClick={() => {
                  window.open(
                    "https://goo.gl/maps/cr9g2Wf8vzxts7ZU7?coh=178572&entry=tt",
                    "_self"
                  );
                }}
              />
            </Box>
          </Box>

          <LazyLoadImage
            effect="opacity"
            src={`${process.env.NEXT_PUBLIC_CDN_LINK}Retail+Page/webp/map.webp`}
            alt="Monuments Animation"
            width="100%"
            onClick={() => {
              window.open(
                "https://goo.gl/maps/cr9g2Wf8vzxts7ZU7?coh=178572&entry=tt",
                "_self"
              );
            }}
          />
        </Box>
      )}
    </CustomBrandLocation>
  );
};

export default BrandLocation;
